import { Component, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { actionClearResult, actionGetProductReviewImages, actionGetTotalProductReviewImages, actionSaveProductReview, getCountPdtReview, getGradeOfProduct, getPdtReview } from '@app/actions/shoppingmall/pdt-detail.action';
import { setWAlert } from '@app/actions/w-alert.action';
import { ActionConstant } from '@app/common/constant/action-constant';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import { AuthUtil } from '@app/common/util/auth.util';
import { ConvertUtil } from '@app/common/util/convert.util';
import { ValidationUtil } from '@app/common/util/validation.util';
import { WAlertStatus } from '@app/models/components/w-alert-stauts.model';
import { ResultProc } from '@app/models/system/result-proc.model';
import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { PdtDetailState, getResultSaveProductReview } from '@app/selectors/shoppingmall/pdt-detail.selector';
import { WAlertState, getWAlertStatus } from '@app/selectors/w-alert.selector';
import { environment } from '@enviroments/environment';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

declare const CKEDITOR: any;

@Component({
  selector: 'review-popup',
  templateUrl: './review-popup.component.html',
  styleUrls: ['./review-popup.component.css']
})
export class ReviewPopupComponent implements OnInit {
  "scripts": [
    "src/assets/js/ckeditor/ckeditor.js",
  ];

  @Input()
  pdtCd: String = "";

  @Input()
  openPopup: boolean = false;

  @Output()
  showPopup = new EventEmitter<boolean>();

  wAlertStatus$ = new Observable<WAlertStatus>();

  resultPdtReview$ = new Observable<ResultProc>();
  resultPdtReview: ResultProc = {} as ResultProc;

  formData = new FormData() as any;

  member = AuthUtil.getLoginedInfo();

  fileName = '';
  filePath = '';
  fileUpload = "";

  grade: number = 0;

  constructor(private renderer: Renderer2,
              private _translateService : TranslateService,
              private _wAlertStore: Store<WAlertState>,
              private _overlayLoadingStore: Store<OverlayLoadingState>,
              private _pdtDetailStore: Store<PdtDetailState>,) {
    this.wAlertStatus$ = this._wAlertStore.select(getWAlertStatus);
    this.resultPdtReview$ = this._pdtDetailStore.select(getResultSaveProductReview);
  }

  ngOnInit(): void {

    this.wAlertStatus$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        if (res.action === ActionConstant.ACTION_SAVE_REVIEW_SUCCESS) {
          this.onClickClosePopup();
          this.clearData();
          let pdtCd = ConvertUtil.convertToSring(this.pdtCd);
          this._pdtDetailStore.dispatch(getCountPdtReview({pdtCd: pdtCd}));
          this._pdtDetailStore.dispatch(getPdtReview({ pdtCd:pdtCd, orderBy:'new', page : 0, len : 5 }));
          this._pdtDetailStore.dispatch(getGradeOfProduct({pdtCd: ConvertUtil.convertToSring(this.pdtCd)}));
          this._pdtDetailStore.dispatch(actionGetProductReviewImages({pdtCd : pdtCd, page : 0, len : 8}));
          this._pdtDetailStore.dispatch(actionGetTotalProductReviewImages({pdtCd : pdtCd}));
        }
      }
    });

    CKEDITOR.replace('contentsNew', {
      toolbar: 'Basic',
      height: '150px'
    });
  }

  onClickClosePopup() {
    this.showPopup.emit(false);
  }

  onClickSetGrade(number : number): void {
    this.grade = number;
    for(let i = 1; i <= number; i++) {
      let element = <HTMLInputElement> document.getElementById('faPopup' + i);
      this.renderer.addClass(element, 'fa-star');
      this.renderer.removeClass(element, 'fa-star-o');
    }

    for(let j = number + 1; j <= 5; j++) {
      let element = <HTMLInputElement> document.getElementById('faPopup' + j);
      this.renderer.addClass(element, 'fa-star-o');
      this.renderer.removeClass(element, 'fa-star');
    }
  }

  onChangeFileSelected(event: any) {
    if(event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadFile(file);
      this.fileUpload = file;
    }
  }

  clearFile() {
    let inputImage = <HTMLInputElement> document.getElementById("fileUpload");
    inputImage.value = "";
    this.filePath = "";
    this.fileUpload = "";
    this.fileName = "";
  }

  uploadFile(file: any) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.filePath = reader.result as string;
    };
  }

  getMessageValidation() : String {
    let message = "";

    if(this.grade == 0) {
      message += this._translateService.instant("msg.review_popup.lbl.001");
      message += "<br>";
    }

    if(ValidationUtil.isNullOrEmpty(CKEDITOR.instances.contentsNew.getData())) {
      message += this._translateService.instant("msg.review_popup.lbl.002");
      message += "<br>";
    }

    return message;
  }

  onSubmitSaveReview() {
    let message = this.getMessageValidation();
    if(ValidationUtil.isNotNullAndNotEmpty(message)) {
      this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.cancelled, message: message } }));
      return;
    }

    this.formData.append('fileData', this.fileUpload);
    this.formData.append('comId', environment.comId);
    this.formData.append('pdtCd', this.pdtCd);
    this.formData.append('contentsNew', CKEDITOR.instances.contentsNew.getData());
    this.formData.append('grade', this.grade);
    this.formData.append('username', ConvertUtil.convertToSring(this.member?.username));
    this.formData.append('userid', ConvertUtil.convertToSring(this.member?.userid));

    this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
    this._pdtDetailStore.dispatch(actionSaveProductReview({ params: this.formData }));

    this.resultPdtReview$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        if(res.keyValue == "OK") {
          let msg = `${res.retCode}`;
          this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.successful, message: msg, action: ActionConstant.ACTION_SAVE_REVIEW_SUCCESS} }));
        } else {
          if(ValidationUtil.isNotNullAndNotEmpty(res.retStr)) {
            this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.cancelled, message: res.retStr } }));
          } else this._wAlertStore.dispatch(setWAlert({ wAlert: { icon: WAlertConstant.cancelled, message: this._translateService.instant("msg.review_popup.lbl.003") } }));
        }
        this._pdtDetailStore.dispatch(actionClearResult({result: {} as ResultProc}))
        this.clearFormData();
        this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: false }));
      }
    });
  }

  clearFormData() {
    this.formData.delete('fileData');
    this.formData.delete('comId');
    this.formData.delete('pdtCd');
    this.formData.delete('contentsNew');
    this.formData.delete('grade');
    this.formData.delete('username');
    this.formData.delete('userid');
  }

  clearData() {
    this.fileUpload = "";
    this.grade = 0;

    this.filePath = '';

    for(let i = 1; i <= 5; i++) {
      let element = <HTMLInputElement> document.getElementById('faPopup' + i);
      this.renderer.addClass(element, 'fa-star-o');
      this.renderer.removeClass(element, 'fa-star');
    }

    CKEDITOR.instances.contentsNew.setData("");
  }

}
